"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:!0}),exports.PlaceholderLabel=exports.PaymentMethod=exports.CardLimitText=exports.Button=void 0;var _styledComponents=_interopRequireDefault(require("styled-components")),_global=require("../../constants/global.constants");const Button=exports.Button=_styledComponents.default.button`
   padding: 16px;
    border: none;
    background: none;
    outline: none;
    cursor: pointer;`,CardLimitText=exports.CardLimitText=_styledComponents.default.div`  
font-weight: 400;
font-size: 16px;
line-height: 24px;
color: #535250;
margin-bottom: 16px;`,PaymentMethod=exports.PaymentMethod=_styledComponents.default.div`
  min-width:336px;
  max-width: 660px;
  .paymentMethodContainer {
    /* Auto layout */
    /* padding: 24px 48px; */
    gap: 24px;
    width: 100%;
    /* height: 380px; */
    background: #ffffff;
    /* Inside auto layout */
    flex: none;
    order: 3;
    flex-grow: 0;
  }
  .mobile{
      width: 336px;
  } 
  
  .paymentHeading {
    width: 424px;
    height: 24px;
    left: 80px;
    top: 24px;
    /* identical to box height, or 120% */
    display: flex;
    align-items: center;
    line-height: 24px;
  }
  .bg{
    background-color: #FAF9F8
  }

  .paymentHeading h4 {
    /* Web/Header/Title Small (SemiBold) */
    /* font-family: 'Nunito Sans'; */
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    margin: 0px 8px;
    /* identical to box height, or 120% */
    font-feature-settings: "liga" off, "calt" off;
    /* Common/Neutral/N800 BrownRegular */
    color: #2a2928;
  }

  .subHeading p {
    /* Web/Header/Title Small (SemiBold) */
    /* font-family: 'Nunito Sans'; */
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height, or 120% */
    font-feature-settings: "liga" off, "calt" off;
    /* Common/Neutral/N800 BrownRegular */
    color: #2a2928;
  }

  .paymentOptionContainer {
    height: fit-content;
    border-radius: 8px;
    border: 1.5px solid #DDD9D5;
    box-sizing: border-box;
    font-size: 16px;
    margin: 8px 0px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .paymentOptionContainer p {
    margin: 0;
    padding-right: 8px;
    padding-bottom: 2px;
  }

  .paymentOptionContainer img {
    max-width: 105px;
    height: 20px;
  }

  .paymentOption {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .creditDebitPaymentOption {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    gap:3px;
    flex-wrap: wrap;
  }

  .paymentOption .cardImg {
    max-width: 24px;
    height: 16px;
    margin-right: 12px;
  }
  .paymentOption .invoiceImg {
    margin-right: 8px;
  }
  .paymentOption .creditDebitImage {
    max-width: 90px;
    height: 16px;
  }
  .paymentOptionContainer .nmoreOTCImage {
    max-width: 24px;
    height: 18px;
    margin-right: 12px;
    mix-blend-mode: darken;
  }
  .paymentOption .paymentImage {
    max-width: 90px;
    height: 16px;
    margin-right: 12px;
  }

  .creditLimit {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #c63939;
    white-space: nowrap;
  }

  .arrIcon {
    font-size: 18px;
  }

  .ebtOption,
  .paypalOptionContainer {
    display: flex;
    align-items: center;
  }

  .ebtOption p,
  .paypalOptionContainer p {
    margin: 0 8px;
  }

  .payPalContainer {
    width: 100%;
    margin: 16px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .payPalContainer .crossBtnContainer {
    width: 100%;
    display: flex;
    justify-content: end;
  }

  .payPalContainer .crossBtnContainer .crossButton {
    padding: 16px;
    border: none;
    background: none;
    outline: none;
    cursor: pointer;
  }

  .payPalContainer h4 {
    /* Web/Header/Title Large */
    font-family: "Nunito Sans";
    font-style: normal;
    font-weight: 300;
    font-size: 28px;
    line-height: 34px;
    /* identical to box height, or 121% */
    text-align: center;
    font-feature-settings: "liga" off, "calt" off;
    /* Common/Neutral/N800 BrownRegular */
    color: #2a2928;
    margin: 0;
    padding: 0;
  }

  .payPalContainer h5 {
    /* Web/Header/Title Large */
    font-family: "Nunito Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    /* or 125% */
    text-align: center;
    font-feature-settings: "liga" off, "calt" off;
    /* Common/Neutral/N800 BrownRegular */
    color: #2a2928;
    margin-bottom: 0;
  }

  .payPalContainer p {
    /* Web/Header/Title Large */
    font-family: "Nunito Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* or 133% */
    text-align: center;
    font-feature-settings: "liga" off, "calt" off;
    /* Neutrals/N2 (Secondary text) */
    color: #7c7575;
  }

  /* .Modal{
    max-width: 700px;
    border: 1px solid #7c7575;
    outline: none;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
  } */
`,PlaceholderLabel=exports.PlaceholderLabel=_styledComponents.default.div`
p{
 font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 18px;
color:#1F1E1E;
margin-bottom: 0px;
}

.learnMore{
    font-weight:600;
    text-decoration: underline;
    color: ${_global.Themes[_global.Banner]};
}

`;